var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesCustomDataIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 6.17578H5C3.895 6.17578 3 7.12478 3 8.29378V18.8818C3 20.0518 3.895 20.9998 5 20.9998H16C17.105 20.9998 18 20.0518 18 18.8818V11.1318L14.086 15.2758C13.7442 15.6413 13.2991 15.8938 12.81 15.9998L10.129 16.5678C8.379 16.9378 6.837 15.3048 7.187 13.4528L7.723 10.6138C7.82 10.1018 8.058 9.63078 8.407 9.26178L11.32 6.17578Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8457 4.31802C19.7446 4.06205 19.5964 3.82732 19.4087 3.62602C19.2242 3.42915 19.0017 3.27165 18.7547 3.16302C18.5114 3.05615 18.2485 3.00098 17.9827 3.00098C17.7169 3.00098 17.454 3.05615 17.2107 3.16302C16.9637 3.27165 16.7412 3.42915 16.5567 3.62602L16.0107 4.20402L18.8627 7.22402L19.4087 6.64502C19.5983 6.44524 19.7468 6.21011 19.8457 5.95302C20.0517 5.42749 20.0517 4.84355 19.8457 4.31802ZM17.4497 8.72102L14.5967 5.70002L9.8197 10.76C9.74922 10.8351 9.70169 10.9288 9.6827 11.03L9.1467 13.87C9.0767 14.24 9.3857 14.566 9.7347 14.492L12.4167 13.925C12.5143 13.9033 12.6031 13.8528 12.6717 13.78L17.4497 8.72102Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesCustomDataIcon);
export default __webpack_public_path__ + "static/media/employees-customData-icon.fc79583c6119292402b831c35b98a46f.svg";
export { ForwardRef as ReactComponent };